import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateMemberChatProfileRequest } from '@nucleus-commerce/api-client/admin';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function useUpdateChatProfile(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateMemberChatProfileRequest) =>
      chatSettingsApi.updateProfile(storeId, body),
    meta: { successMessage: 'chatSettings:toasts.profileSaved', silentError: true },
    onSuccess: (profile) => {
      queryClient.setQueryData(chatSettingsKeys.profile(storeId), profile);
    },
  });
}
